var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPartyPopper(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 28,
    viewBox: "0 0 29 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.8062 15.965L14.8241 21.6188L3.03539 25.0222L6.8062 15.965Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.61328 12C12.5838 12 16.6133 16.0294 16.6133 21C11.6427 21 7.61328 16.9706 7.61328 12Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.36328 12.625L2.61328 26L15.9883 21.2625M5.11328 2.25H5.12578M27.6133 8.5H27.6258M18.8633 1H18.8758M27.6133 23.5H27.6258M27.6133 1L24.8133 1.9375C24.0163 2.20299 23.3362 2.73705 22.8893 3.4484C22.4424 4.15976 22.2565 5.00424 22.3633 5.8375V5.8375C22.4883 6.9125 21.6508 7.875 20.5508 7.875H20.0758C19.0008 7.875 18.0758 8.625 17.8758 9.675L17.6133 11M27.6133 14.75L26.5883 14.3375C25.5133 13.9125 24.3133 14.5875 24.1133 15.725C23.9758 16.6 23.2133 17.25 22.3258 17.25H21.3633M13.8633 1L14.2758 2.025C14.7008 3.1 14.0258 4.3 12.8883 4.5C12.0133 4.625 11.3633 5.4 11.3633 6.2875V7.25",
    stroke: "#5A2D00",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8629 14.75C16.2754 17.1625 17.4004 19.9625 16.3629 21C15.3254 22.0375 12.5254 20.9125 10.1129 18.5C7.70044 16.0875 6.57544 13.2875 7.61294 12.25C8.65044 11.2125 11.4504 12.3375 13.8629 14.75Z",
    stroke: "#5A2D00",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPartyPopper);
export default __webpack_public_path__ + "static/media/party-popper.141875b03a0f121099bcf3d22b370d68.svg";
export { ForwardRef as ReactComponent };